export default {
  props: {
    title: {
      type: String,
    },
    items: {
      type: Array,
    },
    columns: {
      type: String,
      default: 'three-columns',
      validator: prop => ['two-columns', 'three-columns'].includes(prop),
    },
  },

  components: {
    hotCardFeature: () => import('~/components/Molecules/CardFeature/CardFeature.vue'),
  },
}
